module.exports = __webpack_public_path__ + "media/application/images/flags/en-16-bc465932f64fe9916c838c473321d7a3.png";